<script setup lang="ts">
import { BarChart3, BookOpen, House, Map, Settings } from 'lucide-vue-next';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { useLearnerStore } from '@/stores/learner';

const cl_route = useRoute();
const cl_auth = useAuthStore();
const cl_learner = useLearnerStore();
</script>

<template>
  <div class="cl-app-shell">
    <header v-if="cl_auth.cl_authenticated" class="cl-topbar">
      <RouterLink class="cl-brand" to="/">
        <span class="cl-brand-mark"><BookOpen :size="21" /></span>
        <span>AI Phonics Coach</span>
      </RouterLink>
      <div v-if="cl_learner.cl_activeChild" class="cl-child-switcher">
        <label for="cl-child">学习者</label>
        <select id="cl-child" :value="cl_learner.cl_activeChild.id" @change="cl_learner.cl_select(($event.target as HTMLSelectElement).value)">
          <option v-for="cl_child in cl_learner.cl_children" :key="cl_child.id" :value="cl_child.id">{{ cl_child.name }}</option>
        </select>
      </div>
    </header>

    <main :class="['cl-main', { 'cl-main--auth': !cl_auth.cl_authenticated }]">
      <RouterView :key="`${cl_route.fullPath}:${cl_learner.cl_activeChildId}`" />
    </main>

    <nav v-if="cl_auth.cl_authenticated && cl_learner.cl_activeChild" class="cl-bottom-nav" aria-label="主导航">
      <RouterLink to="/" aria-label="首页"><House /><span>首页</span></RouterLink>
      <RouterLink to="/map" aria-label="课程地图"><Map /><span>课程</span></RouterLink>
      <RouterLink to="/parent" aria-label="家长中心"><BarChart3 /><span>报告</span></RouterLink>
      <RouterLink to="/settings" aria-label="学习设置"><Settings /><span>设置</span></RouterLink>
    </nav>
  </div>
</template>
